import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { Link as RouterLink } from '~/lib/react-router-dom';

import { Box, CircularProgress, Link, Paper, Typography } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

import GridPagination from '~/components/Common/Elements/GridPagination';

import * as publicOfferFeedService from '~/services/PublicOfferFeedService';
import { AdCampaign, AdCustomer } from '~/services/PublicOfferFeedService';

function CustomerCampaignListView() {
  const { customerId } = useParams<{ customerId: string }>();
  const [campaigns, setCampaigns] = useState<Array<AdCampaign>>([]);
  const [fetchingState, setFetchingState] = useState<Utils.FetchingState>('idle');

  const columns: Array<GridColDef> = [
    {
      field: 'name',
      headerName: 'Campaign Name',
      flex: 2,
      renderCell: (params) => (
        <Link
          component={RouterLink}
          to={`/marketing/google-ads/customer/${customerId}/campaign/${params.row.id}`}
          underline="hover"
        >
          {params.row.name} ({params.row.id})
        </Link>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
    },
    {
      field: 'budget',
      headerName: 'Budget',
      flex: 1,
      renderCell: (params) => Number(params.row.campaignBudget.amountMicros) / 1_000_000,
    },
  ];

  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        setFetchingState('loading');
        const response = await publicOfferFeedService.getCustomers();
        const customer: AdCustomer | undefined = response.result.find((c: any) => c.id === customerId);
        setCampaigns(customer?.campaigns || []);
        setFetchingState('success');
      } catch (error) {
        console.error('Error fetching campaigns:', error);
        setFetchingState('failed');
      }
    };

    fetchCampaigns();
  }, [customerId]);

  if (fetchingState === 'loading') {
    return (
      <Box p={2} display="flex" justifyContent="center">
        <CircularProgress variant="indeterminate" />
      </Box>
    );
  }

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>
        Campaigns for Customer: {customerId}
      </Typography>

      <DataGrid
        rows={campaigns}
        columns={columns}
        pagination
        paginationMode="client"
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        getRowId={(row) => row.id}
        slots={{ pagination: GridPagination }}
        disableColumnFilter
        disableColumnMenu
        disableRowSelectionOnClick
        autoHeight
      />
    </Paper>
  );
}

export default CustomerCampaignListView;
